// Auth configuration and utilities

export type AuthMode = "production" | "development" | "mock";

interface AuthConfig {
  mode: AuthMode;
  backendUrl: string;
  useServerValidation: boolean;
}

// Determine auth mode based on environment
const getAuthMode = (): AuthMode => {
  const baseUrl = process.env.REACT_APP_API_BASE || "";

  if (baseUrl.includes("railway.app") || baseUrl.includes("production")) {
    return "production";
  }

  if (baseUrl.includes("localhost") || baseUrl.includes("127.0.0.1")) {
    return "development";
  }

  return "mock";
};

// Auth configuration
export const authConfig: AuthConfig = {
  mode: getAuthMode(),
  backendUrl:
    process.env.REACT_APP_API_BASE ||
    "http://localhost:8090/api/v1/development",
  useServerValidation: getAuthMode() !== "mock",
};

// Utility functions
export const shouldUseServerValidation = (): boolean => {
  return authConfig.useServerValidation;
};

export const generateMockToken = (userId: string): string => {
  return `mock_token_${userId}_${Date.now()}`;
};

export const isMockToken = (token: string): boolean => {
  return token.startsWith("mock_token_");
};

// Cookie utilities
export const setCookie = (
  name: string,
  value: string,
  days: number = 1
): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

export const clearCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Strict`;
};

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(";").shift() || null;
  }
  return null;
};
